import React, { Component, FunctionComponent, useRef } from 'react';
import { IRecibospago } from './../pages/interfaces';
import { Grid, Link, Typography } from '@material-ui/core';
import classes from './recibo.module.css';
import { useReactToPrint } from 'react-to-print';
import { getUser } from '../utils/functions';

class ComponentToPrint extends Component<{recibo: IRecibospago}, {}> {
    getTotalPercepciones = (): number => {
        const { recibo } = this.props;
        // Obtenemos importe total de percepciones
        let total = 0;
        for (let i = 0; i < recibo.percepciones.length; i++) {
            const percepcion = recibo.percepciones[i];
            if (!percepcion.esDeduccion) total += percepcion.importe;
        }
        return total;
    }

    getTotalDeducciones = (): number => {
        const { recibo } = this.props;
        // Obtenemos importe total de deducciones
        let total = 0;
        for (let i = 0; i < recibo.percepciones.length; i++) {
            const percepcion = recibo.percepciones[i];
            if (percepcion.esDeduccion) total += percepcion.importe;
        }
        return total;
    }

    getCantidadPercepciones = (): number => {
        const { recibo } = this.props;
        // Obtenemos cantidad total de percepciones
        let cantidad = 0;
        for (let i = 0; i < recibo.percepciones.length; i++) {
            const percepcion = recibo.percepciones[i];
            if (!percepcion.esDeduccion) cantidad += 1;
        }
        return cantidad;
    }

    getCantidadDeducciones = (): number => {
        const { recibo } = this.props;
        // Obtenemos cantidad total de deducciones
        let cantidad = 0;
        for (let i = 0; i < recibo.percepciones.length; i++) {
            const percepcion = recibo.percepciones[i];
            if (percepcion.esDeduccion) cantidad += 1;
        }
        return cantidad;
    }

    generateBlankRows = (tipo: "percepcion" | "deduccion") => {
        let filasAGenerar = 0;
        const minRows = 7;
        const blankRows = [];
        const cantidadPercepciones = this.getCantidadPercepciones();
        const cantidadDeducciones = this.getCantidadDeducciones();
        if (tipo === "percepcion"){
            if (cantidadPercepciones < cantidadDeducciones) {
                if (cantidadDeducciones < minRows) filasAGenerar = (cantidadDeducciones - cantidadPercepciones) + (minRows - cantidadDeducciones)
                else filasAGenerar = cantidadDeducciones - cantidadPercepciones;
            } else filasAGenerar = minRows - cantidadPercepciones;
        }
        if (tipo === "deduccion"){
            if (cantidadDeducciones < cantidadPercepciones) {
                if (cantidadPercepciones < minRows) filasAGenerar = (cantidadPercepciones - cantidadDeducciones) + (minRows - cantidadPercepciones)
                else filasAGenerar = cantidadPercepciones - cantidadDeducciones;
            } else filasAGenerar = minRows - cantidadDeducciones;
        }
        for (let i = 0; i < filasAGenerar; i++) 
            blankRows.push(<tr><td></td><td></td></tr>);
        return blankRows;
    }
    

    render() {
        const user = getUser();
        const { recibo } = this.props;
        return (
            <div className={classes.reciboImpreso} style={{overflow: "auto"}}>
                <img src={require('./../assets/images/isset-watermark.png')} alt="Watermark" style={{position: "absolute", top: "33vh", left: 250}}  />
                <div style={{display: "flex", justifyContent: "space-between"}}>
                    <img src={require('./../assets/images/isset-escudo-tabasco.svg')} alt="ISSET Logo" style={{width: 180}} />
                    <Typography variant="h6" style={{textAlign: "center"}}>
                        INSTITUTO DE SEGURIDAD SOCIAL DEL ESTADO DE TABASCO
                    </Typography>
                </div>
                <table style={{fontSize: 11}} className={classes.tablaRecibo} id={`tablaRecibo${recibo.idRecibo}`}>
                    <thead>
                        <tr>
                            <th>CUENTA</th>
                            <th>NOMBRE</th>
                            <th>RFC</th>
                            <th>CATEGORÍA</th>
                            <th>T/P</th>
                            <th>QNA</th>
                            <th>D.T.</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{recibo.numCuenta.trim() || user.noCuenta}</td>
                            <td>{recibo.nombreTrabajador}</td>
                            <td>{recibo.rfcTrabajador}</td>
                            <td>{recibo.categoria}</td>
                            <td>{recibo.claveTipoPlaza}</td>
                            <td>{recibo.numeroPeriodo}</td>
                            <td>{recibo.diasTrabajados}</td>
                        </tr>
                        <tr>
                            <th colSpan={3}>UNIDAD ADMINISTRATIVA</th>
                            <th colSpan={2}>PERIODO DE PAGO</th>
                            <th>SUELDO DIARIO</th>
                            <th>CVE CATEGORÍA</th>
                        </tr>
                        <tr>
                            <td colSpan={3}>{recibo.unidad}</td>
                            <td colSpan={2}>{recibo.periodo}</td>
                            <td>{recibo.sueldoDiario > 0 ? `$${recibo.sueldoDiario}` : ""}</td>
                            <td>{recibo.claveCategoria}</td>
                        </tr>
                        {recibo.nombreBeneficiario ? 
                        <React.Fragment>
                            <tr>
                                <th colSpan={3}>NOMBRE DEL BENEFICIARIO</th>
                                <th colSpan={4}>RFC DEL BENEFICIARIO</th>
                            </tr>
                            <tr>
                                <td colSpan={3}>{recibo.nombreBeneficiario}</td>
                                <td colSpan={4}>{recibo.rfcBeneficiario}</td>
                            </tr>
                        </React.Fragment>
                        : null}
                        <tr>
                            <td colSpan={7} style={{padding: 0}}>
                                <Grid container>
                                    <Grid item xs={6} style={{height: "100%"}}>
                                        <table className={classes.tablaPercepciones}>
                                            <tbody>
                                                <tr>
                                                    <th style={{width: "70%"}}>PERCEPCIONES</th>
                                                    <th style={{width: "30%"}}>IMPORTE</th>
                                                </tr>
                                                {recibo.percepciones.filter(percepcion => !percepcion.esDeduccion).map(percepcion => (
                                                    <tr key={percepcion.idPercepcion} >
                                                        <td className={classes.conceptoPercepcion}>{percepcion.concepto}</td>
                                                        <td style={{textAlign: "right"}}>${percepcion.importe.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                                    </tr>
                                                ))}
                                                {this.generateBlankRows("percepcion").map((row, index) => <tr key={index} style={{border: "1px solid #ddd", color: "white"}}><td>a</td><td>a</td></tr>)}
                                            </tbody>
                                        </table>
                                    </Grid>
                                    <Grid item xs={6} style={{height: "100%"}}>
                                        <table className={classes.tablaPercepciones}>
                                            <tbody>
                                                <tr>
                                                    <th style={{width: "70%"}}>DEDUCCIONES</th>
                                                    <th style={{width: "30%"}}>IMPORTE</th>
                                                </tr>
                                                {recibo.percepciones.filter(percepcion => percepcion.esDeduccion).map(percepcion => (
                                                    <tr key={percepcion.idPercepcion}>
                                                        <td className={classes.conceptoPercepcion}>{percepcion.concepto}</td>
                                                        <td style={{textAlign: "right"}}>${percepcion.importe.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                                    </tr>
                                                ))}
                                                {this.generateBlankRows("deduccion").map((row, index) => <tr key={index} style={{border: "1px solid #ddd", color: "white"}}><td>a</td><td>a</td></tr>)}
                                            </tbody>
                                        </table>
                                    </Grid>
                                </Grid>
                            </td>
                        </tr>
                        <tr>
                            <th>TOTAL DE PERCEPCIONES</th>
                            <td style={{textAlign: "left"}}>${this.getTotalPercepciones().toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                            <th>TOTAL DE DEDUCCIONES</th>
                            <td style={{textAlign: "left"}}>${this.getTotalDeducciones().toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                            <th>NETO A PAGAR</th>
                            <td style={{textAlign: "left"}} colSpan={2}>${(this.getTotalPercepciones() - this.getTotalDeducciones()).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                        </tr>
                        <tr>
                            <td colSpan={3} style={{backgroundColor: "#d1d1d1"}}>
                                Generado desde INFOISSET<br/>
                                Sello electrónico<br/>
                                {recibo.selloElectronico}
                            </td>
                            <td colSpan={4}>
                                {recibo.observaciones || ""}
                            </td>
                        </tr>
                        <tr style={{backgroundColor: "#5b5b5b"}}>
                            <td colSpan={9}><a style={{color: "white"}} href="http://www.isset.gob.mx">http://www.isset.gob.mx</a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

interface IReciboProps {
    recibo: IRecibospago,
    title: string,
    style?: React.CSSProperties
}

const Recibo: FunctionComponent<IReciboProps> = ({ recibo, title, style }) => {
    const reporteReciboRef = useRef(null);

    const reactToPrintContent = React.useCallback(() => {
        return reporteReciboRef.current;
    }, []);

    const handlePrint = useReactToPrint({
        content: reactToPrintContent,
        documentTitle: "Recibo impreso",
    });

    return (
        <div>
            <Link style={{cursor: "pointer"}} onClick={handlePrint}>
                <span style={style}>
                    {title}
                </span>
            </Link>
            <ComponentToPrint ref={reporteReciboRef} recibo={recibo} />
        </div>
    );
};

export default Recibo;